module.exports = __webpack_public_path__ + "static/media/contract5.faa19213.png";